'use client';

import { ISalePageCommentResponse } from '@/api/types';
import { EmptyView } from '@/components';
import { Column, Element } from '@vuddy/components';
import { isEmpty, isNil } from 'lodash-es';
import { SalePageComment } from '../../[salePageId]/components/comments/comment';

interface SalePageCommentsListProps {
  salePageId?: number;
  comments: ISalePageCommentResponse[];
  interactive?: boolean;
  commentLabel?: string;
}

export const SalePageCommentsList = ({
  salePageId,
  comments,
  interactive = true,
  commentLabel = '댓글',
}: SalePageCommentsListProps) => {
  return isNil(salePageId) || isEmpty(comments) ? (
    <EmptyView
      title={
        <Element typography="bodySmall" color="tertiary">
          첫번째 {commentLabel}을 남겨주세요!
        </Element>
      }
      height={200}
    />
  ) : (
    <Column>
      {comments.map(comment => (
        <SalePageComment
          key={comment.id}
          comment={comment}
          salePageId={salePageId}
          interactive={interactive}
        />
      ))}
    </Column>
  );
};
